export default __webpack_public_path__ + "file/Fiche-EN-Produit-Puroak-Mini-Staves.asset.97a3bb64.pdf";